import { render, staticRenderFns } from "./MobileReactionsPopUp.vue?vue&type=template&id=2a3a5764&scoped=true&"
import script from "./MobileReactionsPopUp.vue?vue&type=script&lang=js&"
export * from "./MobileReactionsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MobileReactionsPopUp.vue?vue&type=style&index=0&id=2a3a5764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a5764",
  null
  
)

export default component.exports